import {createStrokeSVG} from './TEMPLATE'

// tabler: text-size
export const TextSize_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M3 7v-2h13v2',
    'M10 5v14',
    'M12 19h-4',
    'M15 13v-1h6v1',
    'M18 12v7',
    'M17 19h2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
